import { useEffect, useState } from "react";
import useAxios from "@/hooks/useAxios";
import { config } from "@/config";
import { useSelector } from "react-redux";
import { ReduxState } from "@/redux/type";
import LoadingSkeleton from "@/pages/overview/LoadingSkeleton";

export default function ContactInfo() {
    const [contactInfo, setContactInfo] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const customerId = useSelector((state: ReduxState) => state.customer.cardCode);
    const axios = useAxios();

    useEffect(() => {
        async function getContactInfo() {
            setLoading(true);
            try {
                const res = await axios.get(`${config.backendUrl}/customer-contact`, {
                    params: { cardCode: customerId }
                });
                setContactInfo(res.data);
            } catch (error) {
                console.error("Error fetching contact info:", error);
            } finally {
                setLoading(false);
            }
        }
        getContactInfo();
    }, [customerId]);

    if (loading) {
        return <LoadingSkeleton title="Contact Information" lines={3} />;
    }

    if (!contactInfo || contactInfo.length === 0) {
        return (
            <div className="bg-white rounded-lg shadow p-6">
                <h2 className="text-lg font-semibold mb-3">Contact Information</h2>
                <p className="text-gray-500">Unable to load contact information. Please try again later.</p>
            </div>
        );
    }

    const rep = contactInfo[0];

    return (
        <div className="bg-white rounded-lg shadow p-6">
            <h2 className="text-lg font-semibold mb-3">Contact Information</h2>
            <div className="space-y-4">
                <div>
                    <h3 className="text-md font-medium text-gray-700 mb-2">Sales Representative</h3>
                    <div className="space-y-1 text-sm">
                        <div className="flex justify-between">
                            <span className="text-gray-600">Name:</span>
                            <span className="text-right font-medium">{rep.SlpName || "N/A"}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-600">Email:</span>
                            <span className="text-right font-medium">{rep.Email || "N/A"}</span>
                        </div>
                        <div className="flex justify-between">
                            <span className="text-gray-600">Phone:</span>
                            <span className="text-right font-medium">{rep.Telephone || "N/A"}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
} 